import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { DashboardStatsModel } from 'src/app/_models/dashboard/dashboard-stats-model';
import { DashboardStatsModelAdapter } from 'src/app/_models/dashboard/dashboard-stats-model-adapter';
import { ExecutionResult } from 'src/app/_models/execution-result-enum';
import { ExecutionResultDto } from 'src/app/_models/execution-result-model';
import { LinkedInAccessCodeRequest } from 'src/app/_models/social-media/networks/LinkedIn/linked-in-access-code-request';
import { AuthService } from 'src/app/_services/admin/auth/auth.service';
import { DashboardService } from 'src/app/_services/dashboard/dashboard.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { LinkedInService } from 'src/app/_services/social-media/networks/linkedIn.service';
import { CookieStorageService } from 'src/app/_services/system/cookies/cookieStorage.service';
import { PermissionsService } from 'src/app/_services/system/Permissions/permissions.service';
import { environment } from 'src/environments/environment';
import { AutomationStepsCountsModelAdapter } from 'src/app/_models/dashboard/automation-steps-counts-model-adapter';
import { AutomationStepsCountsModel } from 'src/app/_models/dashboard/automation-steps-counts-model';
import { ScheduledCampaignsModel } from 'src/app/_models/dashboard/scheduled-campaigns-model';
import { MatTableDataSource } from '@angular/material/table';
import { ScheduledCampaignsModelAdapter } from 'src/app/_models/dashboard/scheduled-campaigns-model-adapter';
import { DatePipe } from '@angular/common';
import { PreviousCampaignsModel } from 'src/app/_models/dashboard/previous-campaigns-model';
import { PreviousCampaignsModelAdapter } from 'src/app/_models/dashboard/previous-campaigns-model-adapter';
import { MailEdit } from '../shared/constants/app-constants';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  codeParam: string;
  errorParam: string;
  errorDescriptionParam: string;
  loginResponse: string = '';
  userId: string;
  userToken: string;

  linkedInAccessCodeRequest: LinkedInAccessCodeRequest = { AccessCode: ''};
  _dashboardStatsModel: DashboardStatsModel;

  _datePipe = new DatePipe('en-US');

  _automationStepsCountsModel: AutomationStepsCountsModel;

  _scheduledCampaignsRows: ScheduledCampaignsModel[] = [];
  _scheduledCampaignsDataSource = new MatTableDataSource<ScheduledCampaignsModel>([]);

  _scheduledCampaignsDisplayedColumns: string[] = ['Icon', 'MessageName', 'ListName', 'ScheduledDate', 'Preview'];

  _previousCampaignsRows: PreviousCampaignsModel[] = [];
  _previousCampaignsDataSource = new MatTableDataSource<PreviousCampaignsModel>([]);

  _previousCampaignsDisplayedColumns: string[] = ['Icon', 'MessageName', 'ListName', 'ScheduledDate', 'Actions'];

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private cookieStorageService: CookieStorageService,
    private permissionService: PermissionsService,
    private linkedInService: LinkedInService,
    private dashboardService: DashboardService,
    private dashboardStatsModelAdapter: DashboardStatsModelAdapter,
    private automationStepsCountsModelAdapter: AutomationStepsCountsModelAdapter,
    private scheduledCampaignsModelAdapter: ScheduledCampaignsModelAdapter,
    private previousCampaignsModelAdapter: PreviousCampaignsModelAdapter) { }

  // try to retrieve the params from the previous url to attempt to log in (for arriving from Marketing.Delivery platform)
  // if there are parameters, attempt to log in to VB
  // if not, check if already logged in and do nothing if so
  // if not logged in and can't log in, return to login screen and logout
  // also check for returns back from the social media logins and move them to the correct screen (network management)
  async ngOnInit() {
    this.userToken = this.route.snapshot.queryParamMap.get('userToken');
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    var sessionId = this.route.snapshot.queryParamMap.get('sessionId');
    this.codeParam = this.route.snapshot.queryParamMap.get('code');
    this.errorParam = this.route.snapshot.queryParamMap.get('error');
    this.errorDescriptionParam = this.route.snapshot.queryParamMap.get('error_description');
    this._dashboardStatsModel = this.dashboardStatsModelAdapter.createEmpty();
    this._automationStepsCountsModel = this.automationStepsCountsModelAdapter.createEmpty();

    try {
      if (this.userId && this.userToken) {
        await this.authService.loginWithId(this.userId, this.userToken, sessionId, true);
        this.notificationService.showSuccess("Login successful!");
        history.pushState(null, "", location.href.split("?")[0]);
        window.location.reload();               
        return true;
      }
      else if (this.authService.loggedIn()) {
        this.permissionService.getPermission().subscribe(() => {
          this.getDashboardStats();
          //this.getAutomationStepsCountsForToday();
          this.getScheduledCampaigns(1);
          this.getPreviousCampaigns(1);
        });
        
        if(this.codeParam)
        {
          this.linkedInAccessCodeRequest.AccessCode = this.codeParam;
          this.linkedInService.signInWithLinkedIn(this.linkedInAccessCodeRequest).subscribe((executionResultDto: ExecutionResultDto) => {
            if (executionResultDto.executionResult === ExecutionResult.success) {    
              this.notificationService.showSuccess(executionResultDto.message);
            } else {
              this.notificationService.showError(executionResultDto.message);
            }

            this.router.navigate(['network-management']);
          });          
        }
        else if(this.errorParam)
          {
            this.notificationService.showError(decodeURI(this.errorDescriptionParam));
            this.router.navigate(['network-management']);
          }
        
        return true;
      }
    } catch (error) {
      console.log(error);
    }

    this.logout();
    this.notificationService.showError('Login attempt unsuccessful.');
    window.location.assign(environment.loginURL);
  }

  async logout() {   
    localStorage.clear();
    this.cookieStorageService.clearDetailStorage();
   
    this.permissionService.setPermissionsModel = null;
    window.location.assign(environment.loginURL);
  }

  getDashboardStats(){
    this.dashboardService.get().subscribe((executionResultDto: ExecutionResultDto) => {          
      if (executionResultDto.executionResult === ExecutionResult.success) {
        this._dashboardStatsModel = this.dashboardStatsModelAdapter.adapt(executionResultDto.data);
      } else {
        this.notificationService.showError(executionResultDto.message);
      }
    });
  }

  getAutomationStepsCountsForToday() {
      this.dashboardService.getAutomationStepsCountsForToday().subscribe((executionResultDto: ExecutionResultDto) => {          
        if (executionResultDto.executionResult === ExecutionResult.success) {
          this._automationStepsCountsModel = this.automationStepsCountsModelAdapter.adapt(executionResultDto.data);
        } else {
          this.notificationService.showError(executionResultDto.message);
        }
      });
  }

  getScheduledCampaigns(days: number) {
      this.dashboardService.getScheduledCampaigns(days).subscribe((executionResultDto: ExecutionResultDto) => {          
        if (executionResultDto.executionResult === ExecutionResult.success) {
          this._scheduledCampaignsRows = [];
          this._scheduledCampaignsDataSource.data = [];

          if (!executionResultDto.data)
            return;

          this._scheduledCampaignsRows = executionResultDto.data.map(campaign => this.scheduledCampaignsModelAdapter.adapt(campaign));          
          this._scheduledCampaignsDataSource.data = this._scheduledCampaignsRows;          
        } else {
          this.notificationService.showError(executionResultDto.message);
        }
      });
  }

  getPreviousCampaigns(days: number) {
      this.dashboardService.getPreviousCampaigns(days).subscribe((executionResultDto: ExecutionResultDto) => {          
        if (executionResultDto.executionResult === ExecutionResult.success) {
          this._previousCampaignsRows = [];

          if (!executionResultDto.data)
            return;

          this._previousCampaignsRows = executionResultDto.data.map(campaign => this.previousCampaignsModelAdapter.adapt(campaign));          
          this._previousCampaignsDataSource.data = this._previousCampaignsRows;
        } else {
          this.notificationService.showError(executionResultDto.message);
        }
      });
  }

  viewMessage(selectedRow: any) {
    const path = selectedRow.MessageType === 1 || selectedRow.MessageType === 3
      ? selectedRow.PreviewUrl
      : 'messages/sms-message';

    if (selectedRow.MessageType == 2) {
      const url = this.router.serializeUrl(this.router.createUrlTree([path, selectedRow.MessageId]))
      window.open(url, '_blank');
    } else {
      window.open(path, '_blank');
    }
  }

  viewReport(selectedRow: any) {
    const path = selectedRow.MessageType === 1 || selectedRow.MessageType === 3
      ? 'email-reports/details/'
      : 'sms-reports/details/';

    const url = this.router.serializeUrl(this.router.createUrlTree([path, selectedRow.ReportId]))
    window.open(url, '_blank');
  }

  getFaIconName(percentage) {
    if (percentage > 0) {          
      return 'arrow-up';      
    } else if (percentage) {
      return 'arrow-down';      
    } else {      
      return 'minus-square';      
    }
  }

  getPercentageColour(percentage) {
    if (percentage > 0) { 
      return 'green'
    } else if (percentage < 0) {      
      return 'red';
    } else {
      return 'grey';
    }
  }

  onButtonGroupClick($event){
    let clickedElement = $event.target || $event.srcElement;

    if( clickedElement.nodeName === "BUTTON" ) {
      let isCertainButtonAlreadyActive = clickedElement.parentElement.querySelector(".active");
      if( isCertainButtonAlreadyActive ) {
        isCertainButtonAlreadyActive.classList.remove("active");
      }

      clickedElement.className += " active";
    }

  }
}